import { ChainId } from '@pancakeswap/sdk';
import MULTICALL_ABI from './abi.json';

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x41263cBA59EB80dC200F3E2544eda4ed6A90E76C',
  [ChainId.TESTNET]: '0xae11C5B5f29A6a25e955F0CB8ddCc416f522AF5C',
};

export { MULTICALL_ABI, MULTICALL_NETWORKS };
